import classNames from 'classnames';
import CourseRatingView from 'components/common/CourseRatingView';
import Icon from 'components/common/Icon';
import RichContent from 'components/common/RichContent';
import UserInfo from 'components/common/UserInfo';
import { CourseInfo } from 'service/course';
import styles from './CourseOverview.module.scss';

const CourseOverview = ({ courseInfo }: { courseInfo: CourseInfo }) => {
  if (!courseInfo) return <></>;
  return (
    <div className={styles.courseOverview}>
      <div className={styles.creatorInfoWrapper}>
        <UserInfo user={courseInfo.user} avatarSize={36} badgeSize={32} />
        <CourseRatingView
          count={courseInfo.review_summary?.count}
          rating={courseInfo.review_summary?.rating}
          className={styles.ratingSection}
        />
      </div>
      <div
        className={classNames(styles.courseTitle, {
          [styles.blank]: !courseInfo.title,
        })}
      >
        {courseInfo.title ? courseInfo.title : 'タイトル'}
      </div>
      <div className={styles.categories}>
        {(courseInfo.domains || []).map((domain) => {
          return (
            <div className={styles.categoryItem} key={`domain-${domain.name}`}>
              {domain.name}
            </div>
          );
        })}
      </div>
      <div className={styles.infoTitle}>コースの詳細</div>
      {courseInfo.description ? (
        <div className={styles.courseDescription}>
          <RichContent text={courseInfo.description} />
        </div>
      ) : (
        <div className={styles.blankInfo}>コースの詳細</div>
      )}
      <div className={styles.infoTitle}>コースの対象者</div>
      {!courseInfo.target_user ? (
        <div className={styles.blankInfo}>どういった方に向けたコースか</div>
      ) : (
        <div className={styles.targetCustomer}>{courseInfo.target_user}</div>
      )}
      <div className={styles.infoTitle}>コースで学べる事</div>
      {!courseInfo.benefits ||
      courseInfo.benefits.length === 0 ||
      (courseInfo.benefits.length === 1 && !courseInfo.benefits[0]) ? (
        <div className={styles.blankInfo}>どのようなことを学べるコースか</div>
      ) : (
        <div className={styles.benefits}>
          {(courseInfo.benefits || [])
            .filter((benefit) => !!benefit.trim())
            .map((benefit, index) => {
              return (
                <div key={`benefit-${index}`} className={styles.benefit}>
                  <div className={styles.icon}>
                    <Icon name="done" width={18} height={18} />
                  </div>
                  <span className={styles.benefitContent}>{benefit}</span>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default CourseOverview;
